import { render, staticRenderFns } from "./AuthorizerDialogComponent.vue?vue&type=template&id=5423a1e6&scoped=true&"
import script from "./AuthorizerDialogComponent.vue?vue&type=script&lang=js&"
export * from "./AuthorizerDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizerDialogComponent.vue?vue&type=style&index=0&id=5423a1e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423a1e6",
  null
  
)

export default component.exports